import { useState, useCallback } from 'react';
import { services } from '../../../context';
import { AccountDetails } from '@v2/types';

interface UseUpdateAccountResult {
  updateAccount: (id: string, data: Partial<AccountDetails>) => Promise<boolean>;
  loading: boolean;
  error: string | null;
}

export const useUpdateAccount = (): UseUpdateAccountResult => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const updateAccount = useCallback(async (id: string, data: Partial<AccountDetails>): Promise<boolean> => {
    setLoading(true);
    setError(null);

    try {
      const axiosInstance = services.axios.Axios();
      await axiosInstance.patch(`accounts/${id}`, data);
      return true;
    } catch (err: unknown) {
      setError('Failed to update account');
      console.error('Error updating account:', err);
      return false;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    updateAccount,
    loading,
    error,
  };
};

export default useUpdateAccount;
